import Popover from '@mui/material/Popover';
import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import { getPopoverPaperSx, popoverDefaultSlotProps } from './popoverStyles';
const PopoverView = ({ visible, anchorEl, component, onClose, dismissable = true, anchorOrigin = popoverDefaultSlotProps.anchorOrigin, transformOrigin = popoverDefaultSlotProps.transformOrigin, paperSx, matchAnchorWidth, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const anchorWidth = matchAnchorWidth
        ? anchorEl?.getBoundingClientRect?.().width
        : undefined;
    return (React.createElement(Popover, { open: visible && !!anchorEl, anchorEl: anchorEl, onClose: dismissable ? onClose : undefined, disableScrollLock: popoverDefaultSlotProps.disableScrollLock, anchorOrigin: anchorOrigin, transformOrigin: transformOrigin, slotProps: {
            paper: {
                sx: getPopoverPaperSx(theme, anchorWidth, paperSx),
            },
        } }, component));
};
const stylesGenerator = createThemedStyle(() => ({}));
export default PopoverView;
